import React from 'react';
// import DropBalls from './DropBalls';
import './Quote.scss';
import quotemark from '../assets/elements/quotemark-icon.svg';
const defaultQuote = {
  author: null,
  position: '',
  img: null,
  quote: ['', '']
}

export default ({ isActive, quote=defaultQuote, position='', delay=0, showQuotemark=true }) => {
  const QuoteMarkComponent = () => {
    return (
      <div className="quote-mark" >
        <img src={quotemark} alt={`quotation mark`}/>
      </div>
    );
  }
  return (
    <div className={`quote ${position}`}>
      <div className="quote-text">
      {showQuotemark === true ? (<QuoteMarkComponent />) : ''}
        <p>{quote.quote[0]}</p>
        {quote.quote && quote.quote.map((q, i) => {
          if (i !== 0) {
            return (<><p className="sub-quote">{quote.quote[i]}</p></>);
          } else {
            return <><br className="hide-landscape"></br></>;
          }
        })}
        {quote.author && (
          <div className="author">
            <div className="headshot">
              <img src={quote.img} alt="Alice Shaw" />
            </div>
            <div>
              <p className="author-name">{quote.author}</p>
              <p className="author-position">{quote.position}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}